import { Component, Input, OnInit, ViewChild, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomToastService } from '../../../../../../services/custom-toast.service';
import { PlantmanagerService } from '../../services/plantmanager.service';
import { ConnectorChild, PlantList } from '../../models/plant-manager.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicControlsComponent, Section } from 'src/app/Modules/management/components/modals/organization/dynamic-controls/dynamic-controls.component';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { PageType } from 'src/app/Modules/idms/enums/PageType';
import { IdmApiService } from 'src/app/services/idmapi.service';
import { ManagementApiService } from 'src/app/services/management-api.service';
import { TranslocoService } from '@jsverse/transloco';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';

@Component({
    selector: 'add-tagged-item-modal.component',
    templateUrl: './add-tagged-item-modal.component.html',
    styleUrls: ['./add-tagged-item-modal.component.scss'],
})
export class AddTaggedItemModalComponent implements OnInit, OnDestroy {
    @Input() selectedConnectorChild: ConnectorChild;
    @ViewChild('userCard') itemCard: ElementRef;
    destroy$ = new Subject();
    FinalSave: BehaviorSubject<UntypedFormGroup> = new BehaviorSubject<UntypedFormGroup>(null);

    selectedtaggedItem: PlantList;
    searchInput: string;
    isTaggedItemSelected: boolean = false;
    selectedTaggedItemNumber: number;
    taggedItemListCopy: PlantList[];
    radioOptions: string = '';
    AddBtn: string = this.transLocoService.translate(`PLANT_MANAGER.Add`);
    searchDisabled: boolean = true;
    taggedItemList: PlantList[];
    jsonObject: Section[];
    NamePrimaryKey: string;
    NameSecondaryKey: string;
    NamePrimary: string;
    NameSecondary: string;
    ImageUrl: string;
    IselectFromExist: boolean = false;

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private plantmanagerServiceser: PlantmanagerService,
        private cd: ChangeDetectorRef,
        private customToastService: CustomToastService,
        private modalService: NgbModal,
        private idmApiService: IdmApiService,
        private managementApiService: ManagementApiService,
        private transLocoService: TranslocoService,
        private globalEmittersService: GlobalEmittersService
    ) {}

    ngOnInit(): void {
        this.AddBtn = this.transLocoService.translate(`PLANT_MANAGER.Add`);
        this.GetTaggedItemByType();
    }

    onRadioButtonChange(event) {
        if (event.value == '1') {
            this.AddBtn = this.transLocoService.translate(`PLANT_MANAGER.Add`);
            this.searchDisabled = false;
            this.IselectFromExist = true;
        } else {
            this.AddBtn = this.transLocoService.translate(`PLANT_MANAGER.Next`);
            this.searchInput = '';
            this.searchDisabled = true;
            this.IselectFromExist = false;
        }
    }

    GetTaggedItemByType() {
        let selectedTaggedItemType = this.selectedConnectorChild.taggedItemTypeId;
        this.idmApiService
            .GetTaggedItemByTypes([selectedTaggedItemType])
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (response: any) => {
                    if (response.success) {
                        this.taggedItemListCopy = response.response;
                        this.taggedItemList = response.response;
                    } else {
                        this.customToastService.errorToast(this.transLocoService.translate(`PLANT_MANAGER.ErrorWhileReceiveData`), 'Error');
                    }
                },
                (error) => {
                    this.customToastService.errorToast(this.transLocoService.translate(`PLANT_MANAGER.ErrorWhileReceiveData`), 'Error');
                }
            );
    }

    //To select existing tagged items
    selectItem(item: any, selectedItem: number) {
        this.isTaggedItemSelected = true;
        this.selectedtaggedItem = item;
        let element = <HTMLElement>this.itemCard.nativeElement;
        let children = [];
        for (let x = 0; x < element.children.length; x++) {
            element.children[x].classList.remove('user-active');
        }
        let x = document.getElementById(`user-${selectedItem} ${item.namePrimary}`);
        x.classList.add('user-active');
        this.selectedTaggedItemNumber = selectedItem;
    }

    persistTheItemSelection() {
        if (this.isTaggedItemSelected) {
            let x = document.getElementById(`user-${this.selectedTaggedItemNumber} ${this.selectedtaggedItem.namePrimary} `);
            if (x) {
                x.classList.add('user-active');
            }
        }
    }

    addClick() {
        if (this.IselectFromExist) {
            let params = {
                connectorParentId: this.selectedConnectorChild.connectorParentId,
                taggedItemId: this.selectedtaggedItem.taggedItemId,
            };
            this.idmApiService
                .postConnectors([params])
                .pipe(takeUntil(this.destroy$))
                .subscribe(
                    (response: any) => {
                        if (response.success) {
                            this.ngbActiveModal.close(this.selectedtaggedItem);
                            if (this.plantmanagerServiceser.activeTaggedItem)
                                this.plantmanagerServiceser.UpdateActiveTaggedItem.next(this.plantmanagerServiceser.activeTaggedItem);
                            this.cd.detectChanges();
                        } else {
                            this.customToastService.errorToast(response.message, 'Error');
                        }
                    },
                    (error) => {
                        this.customToastService.errorToast(this.transLocoService.translate(`PLANT_MANAGER.ErrorWhileSaveConnector`), 'Error');
                    }
                );
        } else {
            let schemaVersionId = this.selectedConnectorChild.schemaVersionId;

            this.managementApiService
                .GetSchemaVersions(schemaVersionId, localStorage.getItem('currentInstanceId'))
                .toPromise()
                .then((res) => {
                    if (res.success) {
                        this.globalEmittersService.selectedTool = null;
                        this.OpenDynamicComponent(res.response.schema);
                    } else {
                        this.customToastService.errorToast(this.transLocoService.translate(`PLANT_MANAGER.ErrorWhileReceiveData`), 'Error');
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });
        }
    }

    OpenDynamicComponent(jsonString: string) {
        let dialogRef = this.modalService.open(DynamicControlsComponent, {
            size: 'lg',
        });

        dialogRef.componentInstance.jsonString = jsonString;
        dialogRef.componentInstance.selectedConnectorChild = this.selectedConnectorChild;
        dialogRef.componentInstance.mode = 'pop-up';
        dialogRef.componentInstance.pagetitle = this.selectedConnectorChild.taggedItemType
            ? this.transLocoService.translate(`PLANT_MANAGER.Create`) + ' ' + this.selectedConnectorChild.taggedItemType
            : this.transLocoService.translate(`PLANT_MANAGER.CreateTaggedItem`);
        dialogRef.componentInstance.PageType = PageType.PlantManagerCreate;
        dialogRef.componentInstance.permission = true;
        dialogRef.result.then((ObjSave: any = []) => {}).catch((error) => {
            console.warn(error);});
    }

    GetSchemaVersions() {
        let schemaVersionId = this.selectedConnectorChild.schemaVersionId;
        this.managementApiService
            .GetSchemaVersions(schemaVersionId, localStorage.getItem('currentInstanceId'))
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (response: any) => {
                    if (response.success) {
                        let jsonString = response.response.schema;
                    } else {
                        this.customToastService.errorToast(this.transLocoService.translate(`PLANT_MANAGER.ErrorWhileReceiveData`), 'Error');
                    }
                },
                (error) => {
                    this.customToastService.errorToast(this.transLocoService.translate(`PLANT_MANAGER.ErrorWhileReceiveData`), 'Error');
                }
            );
    }

    closeClick() {
        this.ngbActiveModal.close();
    }

    searchResult(event) {
        if (!event.target.value) {
            this.taggedItemList = this.taggedItemListCopy;
        } else {
            this.taggedItemList = this.taggedItemListCopy.filter((item) => {
                return (item.namePrimary !== undefined ? item.namePrimary : '')
                    .toLowerCase()
                    .replace(/\s+/g, '')
                    .trim()
                    .includes(event.target.value.toString().replace(/\s+/g, '').trim().toLowerCase());
            });
        }

        if (this.taggedItemList != null || this.taggedItemList != undefined) {
            this.persistTheItemSelection();
        }
    }

    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
